import { Routes } from '@angular/router';
import { authGuard } from '@core/guards';
import { LayoutComponent } from '@layout/layout.component';

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./routes/login/login.routes').then(m => m.routes),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'error',
        loadChildren: () =>
          import('./routes/error/error.routes').then(m => m.routes),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./routes/dashboard/dashboard.routes').then(m => m.routes),
      },
      {
        path: 'campaign',
        loadChildren: () =>
          import('./routes/campaign/campaign.routes').then(m => m.routes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'error/404',
  },
];
